import { render, staticRenderFns } from "./AcompanharDeclaracao.vue?vue&type=template&id=3ea8cf09&scoped=true&"
import script from "./AcompanharDeclaracao.vue?vue&type=script&lang=js&"
export * from "./AcompanharDeclaracao.vue?vue&type=script&lang=js&"
import style0 from "./AcompanharDeclaracao.vue?vue&type=style&index=0&id=3ea8cf09&scoped=true&lang=css&"
import style1 from "./AcompanharDeclaracao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8cf09",
  null
  
)

export default component.exports